import React from 'react';
import styled, { css } from 'styled-components';
import {Box} from './Flex';

export const Text = styled(Box)`
  ${props => props.semibold && css`
    font-weight: 600;
  `};

  ${props => props.bold && css`
    font-weight: 700;
  `};

  ${props => props.cap && css`
    text-transform: capitalize;
  `}
`;
